type ParamValues = Record<string, unknown>;

/**
 * Fills the path placeholders and appends the query the way ASP.NET binds it: an array repeats its key
 * (ids=1&ids=2), a Date is ISO 8601, and a null or undefined value is left out.
 */
export function buildApiUrl(
  path: string,
  params: { path?: ParamValues; query?: ParamValues } = {}
): string {
  const fillPlaceholder = (_: string, name: string) => {
    const value = params.path?.[name];

    if (value === undefined || value === null) {
      throw new Error(`${path} needs a value for {${name}}.`);
    }

    return encodeURIComponent(formatValue(value));
  };

  const query = new URLSearchParams();

  for (const [key, value] of Object.entries(params.query ?? {})) {
    for (const item of Array.isArray(value) ? value : [value]) {
      if (item !== undefined && item !== null) {
        query.append(key, formatValue(item));
      }
    }
  }

  const filledPath = path.replace(/\{(\w+)\}/g, fillPlaceholder);
  const search = query.toString();

  return search ? `${filledPath}?${search}` : filledPath;
}

function formatValue(value: unknown): string {
  return value instanceof Date ? value.toISOString() : String(value);
}
